$(document).ready(function () {
    ///

    $.fancybox.defaults.backFocus = false;

    const renderStars = (element) => {
        const rating = element.attr('data-rating');
        let c = 0;
        element.find('.rating-stars__star').removeClass('filled').each(function () {
            if (c < Math.floor(rating)) {
                $(this).addClass('filled');
                c++;
            }
        })
    }


    $(document).on('updateStars', function () {
        $('.js-stars').each(function () {
            renderStars($(this));
        });
    });
    $(document).trigger('updateStars');

    $('.js-checkbox').on('click', function (e) {
        if (e.target.tagName.toLowerCase() !== 'a') {
            e.preventDefault()
            let isChecked = $(this).find('input[type="checkbox"]').prop('checked');
            $(this).toggleClass('checked').find('.custom-cb-badge, .custom-cb-badge-allow').toggleClass('checked');
            $(this).find('input[type="checkbox"]').prop('checked', !isChecked).change();
        }
    });

    $(document).on('click', '.js-open-picker', function (e) {
        e.preventDefault();

        $('.color-size-picker').removeClass('opened');
        $(this).parents('.product-preview').find('.color-size-picker').addClass('opened');
        if (screen.width < 768) {
            $(this).parents('.product-slider-redesign').addClass('arrows-hidden');
        }
    });

    $(document).on('click', '.js-add-to-cart', function (e) {
        e.preventDefault();
        const parent = $(this).parents('.product-preview');
        const cartBtn = parent.find('.product-preview__add-to-cart');

        $(this).parents('.color-size-picker').removeClass('opened');
        cartBtn.addClass('active');
        cartBtn.text('Добавлено в корзину');
        if (parent.hasClass('product-preview--accessory')) {
            cartBtn.text('В корзину')
        }
        if (screen.width < 768) {
            $(this).parents('.product-slider-redesign').removeClass('arrows-hidden');
        }
    });

    $(document).on('click', function (e) {
        if (!$('.color-size-picker').is(e.target) && $('.color-size-picker').has(e.target).length === 0 && !$('.js-open-picker').is(e.target) && $('.js-open-picker').has(e.target).length === 0) {
            $('.color-size-picker').removeClass('opened');
        }
    });

    $(document).on('click', '.js-active-toggle', function () {
        $(this).toggleClass('active');
    });

    $(document).on('click', '.js-only-active-toggle', function () {
        $(this).parent().find('.js-only-active-toggle').removeClass('active')
        $(this).addClass('active');
    });

    // $(document).on('click', '.js-product-card-cart', function (e) {
    //     e.preventDefault();
    //     $(this).addClass('active');
    //     $(this).find('span').text('Перейти в корзину');
    // });

    // Sliders

    $('.js-product-slider-redesign').each(function () {
        let slides = $(this).find('.swiper-slide');

        if (slides.length > 1) {
            const productSliderRedesign = new Swiper(this, {
                loop: true,
                slidesPerView: 2,
                spaceBetween: 0,
                observer: true,
                observeParents: true,
                observeSlideChildren: true,
                watchOverflow: true,
                lazy: {
                    loadPrevNext: true,
                },
                navigation: {
                    nextEl: $(this).find('.product-slider-redesign__arrow--next')[0],
                    prevEl: $(this).find('.product-slider-redesign__arrow--prev')[0],
                },
                breakpoints: {
                    1199: {
                        slidesPerView: 4,
                        watchOverflow: true,

                    },
                    991: {
                        slidesPerView: 3,
                        watchOverflow: true,

                    },
                    600: {
                        slidesPerView: 2,
                        watchOverflow: true,
                    },
                }
            });
        } else {
            $(this).find('.product-slider-redesign__arrow').hide();
            $(this).addClass('disabled');
        }
    });

    $('.js-gallery-slider').each(function () {
        let slides = $(this).find('.swiper-slide');

        if (slides.length > 1) {
            const gallerySlider = new Swiper(this, {
                loop: true,
                slidesPerView: 1,
                spaceBetween: 15,
                watchOverflow: true,
                lazy: {
                    loadPrevNext: true,
                },
                navigation: {
                    nextEl: $(this).find('.gallery-slider__arrow--next')[0],
                    prevEl: $(this).find('.gallery-slider__arrow--prev')[0],
                },
                breakpoints: {
                    992: {
                        slidesPerView: 3,
                        watchOverflow: true,

                    },
                    600: {
                        slidesPerView: 2,
                        watchOverflow: true,
                    },
                }
            });
        } else {
            $(this).find('.product-slider-redesign__arrow').hide();
            $(this).addClass('disabled');
        }
    });


    let div = document.createElement('div');

    div.style.overflowY = 'scroll';
    div.style.width = '50px';
    div.style.height = '50px';

    document.body.append(div);
    const scrollWidth = div.offsetWidth - div.clientWidth;
    div.remove();

    const renderClickableBG = (isDark, elementToClose, id, renderParent = $('body'), blockScroll = true) => {
        renderParent.append(`<div class="clickable-bg" id=${id}></div>`);
        if (blockScroll) {
            $('body').css({
                'padding-right': scrollWidth,
                'overflow-y': 'hidden',
            });
            $('.ns-header.fixed').css({
                'transition': 'none',
                'width': `calc(100% - ${scrollWidth}px)`
            })
        }
        if (isDark) {
            $('.clickable-bg').addClass('clickable-bg--dark').fadeOut(1).fadeIn(400);
        }
        $(document).on('click', '.clickable-bg', function () {
            $(this).remove();
            if (elementToClose) {
                elementToClose.removeClass('opened');
                if (blockScroll) {
                    $('body').css({
                        'padding-right': 0,
                        'overflow-y': 'auto',
                    });
                    $('.ns-header.fixed').css({
                        'width': '100%',
                    })
                    setTimeout(function () {
                        $('.ns-header.fixed').css({
                            'transition': '.1s ease-in-out',
                        }, 200)
                    })
                }
            }
        })
    }


    // Modals

    const openModal = (modal, bgId) => {
        $('.modal').removeClass('opened');
        $('.modal').removeClass('open');
        $('.modal').removeAttr("style");
        $(bgId).remove();
        modal.addClass('opened');
        renderClickableBG(true, modal, bgId, modal)
    }

    window.openModal = openModal;

    const closeModal = (modal, bg = null) => {
        $('.modal').removeAttr("style");
        modal.removeClass('opened');
        if (bg) {
            bg.remove();
        }
        $('body').css({
            'padding-right': 0,
            'overflow-y': 'auto',
        });
        $('.ns-header.fixed').css({
            'width': '100%',
        })
        setTimeout(function () {
            $('.ns-header.fixed').css({
                'transition': '.1s ease-in-out',
            }, 200)
        })
    }

    $(document).on('click', '.js-open-modal', function (e) {
        e.preventDefault();
        const modal = $($(this).attr('data-modal'));
        openModal(modal, 'modal-bg')
    });

    $(document).on('click', '.js-close-modal', function () {
        const modal = $(this).parents('.modal');
        const bg = $(this).parents('.modal').find('#modal-bg');
        closeModal(modal, bg);
    });

    $(document).on('click', '.js-submenu-toggle', function (e) {
        e.preventDefault();

        if (!$(this).hasClass('active')) {
            $(this).addClass('active')
            $(this).parent().addClass('active').siblings('.js-submenu').slideDown().addClass('opened');
        } else {
            $(this).removeClass('active')
            $(this).parent().removeClass('active').siblings('.js-submenu').slideUp().removeClass('opened');
        }
    });

    $(document).on('click', '.js-category-mobile-toggle', function () {
        if (!$(this).hasClass('opened')) {
            $(this).siblings('.category-sidebar__category-items').slideDown();
            $(this).addClass('opened');
        } else {
            $(this).siblings('.category-sidebar__category-items').slideUp();
            $(this).removeClass('opened');
        }
    });

    $(document).on('click', function (e) {
        const catalogMenu = $('.catalog-menu');
        const catalogMenuToggler = $('.js-catalog-menu-toggle');

        if (!catalogMenu.is(e.target) && catalogMenu.has(e.target).length === 0
            && !catalogMenuToggler.is(e.target) && catalogMenuToggler.has(e.target).length === 0) {
            catalogMenu.slideUp(150, function () {
                catalogMenu.removeClass('opened');
            });
            $('#catalog-menu-bg').remove();
            $('body').css({
                'padding-right': 0,
                'overflow-y': 'auto',
            });
            $('.ns-header.fixed').css({
                'width': '100%',
            })
            setTimeout(function () {
                $('.ns-header.fixed').css({
                    'transition': '.1s ease-in-out',
                }, 200)
            })
            $('.catalog-menu__submenu-box').removeClass('opened');
            $('.catalog-menu__submenu-box').eq(0).addClass('opened');
            $('.catalog-menu__submenu-box').eq(0).find(">:first-child").scrollTop(0);
        }
    })

    $(document).on('mouseenter', '.js-catalog-submenu-toggle', function () {
        $('.catalog-menu__submenu-box.opened')
            .not($(this).find('.catalog-menu__submenu-box'))
            .not($(this).parents('.catalog-menu__submenu-box')).removeClass('opened');
        $(this).find('.catalog-menu__submenu-box').eq(0).addClass('opened');
    }).on('mouseenter', '.catalog-menu__nav-item', function () {
        if (!$(this).hasClass('js-catalog-submenu-toggle')) {
            $('.catalog-menu__submenu-box').removeClass('opened');
        }
    }).on('click', '.js-rating-star > div', function(){
        const index = $(this).index(), $wrap = $(this).parent();

        $wrap.children('div:lt('+(index + 1)+')').addClass('filled');
        $wrap.children('div:gt('+index+')').removeClass('filled');
    });

    if (screen.width < 1101) {
        $('.footer__nav-title').removeClass('active');
        $('.footer__nav-items').removeClass('opened');
    }
});
